import { Grid } from '@simplywallst/ui-core';
import { Props } from '../types';
import { NarrativeFeedback } from '../../NarrativeFeedback';
import { NarrativeHeader } from '../../NarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';

export const DesktopLayout = ({
  errors,
  values,
  onChange,
  isLoading,
  onSubmit,
  submitLabel,
  userDisplayName,
  initialContentHtml,
  company,
  onReset,
}: Props) => {
  return (
    <>
      <Grid
        templateRows="min-content min-content auto"
        gap="16px"
        alignContent="flex-start"
      >
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={onChange}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={submitLabel}
          userDisplayName={userDisplayName}
        />
        <NarrativeFeedback />
        <PublicNarrativeRichTextEditor
          onUpdate={(content) => onChange({ content })}
          defaultContent={initialContentHtml}
        />
      </Grid>
      <Grid alignItems="flex-start">
        <NarrativeSidebar
          company={company}
          onChange={onChange}
          values={values}
          onReset={onReset}
          readOnly={false}
          authorDisplayName={userDisplayName}
        />
      </Grid>
    </>
  );
};
